import type { DesignBoardPreviewProps } from '@modules/design-board/util/map-member-board-list-pin-data';
import BoardTileGrid from '~/modules/design-board/component/board-list/BoardTileGrid';
import BoardListFilter from '~/modules/design-board/component/board-list/BoardListFilter';
import NoBoardState from '~/modules/design-board/component/board-list/NoBoardState';
import MainContentLayout from '~/modules/design-board/component/page-layout/MainContentLayout';
import BottomPagination from '~/modules/design-board/component/pagination/BottomPagination';
import type { PaginationOptions } from '~/modules/root/util/get-pagination-opts.server';
import type { BoardListWithImageOnlyPinsFragment } from 'generated/graphql';

import {
    EMPTY_SIDE_NAV_ITEM,
    PROJECT_INDEX_PAGE_SIDE_ITEMS,
} from '~/modules/design-board/config/design-board-config';
import { useUser } from '~/modules/user';
import LeftSideNav from '../left-side-nav/LeftSideNav';

interface BoardListProps {
    boardListData: BoardListWithImageOnlyPinsFragment[];
    previewListData: DesignBoardPreviewProps[];
    pagination: PaginationOptions;
}

const BoardList = ({
    previewListData,
    boardListData,
    pagination,
}: BoardListProps) => {
    const user = useUser();

    const isLoggedIn = user.__typename === 'Me';
    const isClient =
        isLoggedIn &&
        user &&
        'Professionals' in user &&
        user.Professionals.length;

    return (
        <MainContentLayout
            topComponent={<BoardListFilter />}
            leftSideNav={
                <LeftSideNav
                    topItem={EMPTY_SIDE_NAV_ITEM}
                    navItems={PROJECT_INDEX_PAGE_SIDE_ITEMS}
                    previewTag={isClient ? 'sign up for beta' : 'soon'}
                />
            }
        >
            {boardListData.length === 0 ? (
                <NoBoardState />
            ) : (
                <BoardTileGrid
                    boardListData={boardListData}
                    previewListData={previewListData}
                />
            )}

            <BottomPagination pagination={pagination} itemName="Board" />
        </MainContentLayout>
    );
};

export default BoardList;
